import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom'
import BlogSidebar from '../BlogSidebar/BlogSidebar.js'
import { getNews } from '../../api/backend'

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const BlogList = (props) => {
    const [blogs, setBlogs] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        getNews()
            .then(res => setBlogs(res.data || []))
            .catch(err => console.error('Errore caricamento news:', err))
            .finally(() => setLoading(false))
    }, [])

    return (
        <section className="wpo-blog-pg-section section-padding">
            <div className="container">
                <div className="row">
                    <div className={`col col-lg-8 col-12 ${props.blRight}`}>
                        <div className="wpo-blog-content">
                            {loading ? (
                                <p>Caricamento articoli...</p>
                            ) : (
                                blogs.map((blog, bitem) => (
                                    <div className="post format-standard-image" key={blog.id || bitem}>
                                        <div className="image">
                                            {blog.image_url && (
                                                <img src={blog.image_url} alt={blog.title} />
                                            )}
                                        </div>
                                        <div className="entry-meta">
                                            <ul>
                                                <li><i className="fi flaticon-user"></i> By <Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`}>{blog.author}</Link></li>
                                                <li><i className="fi flaticon-calendar"></i> {blog.formatted_date}</li>
                                            </ul>
                                        </div>
                                        <div className="entry-details">
                                            <h3><Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`}>{blog.title}</Link></h3>
                                            <p>{blog.description}</p>
                                            <Link onClick={ClickHandler} to={`/blog-single/${blog.slug}`} className="read-more">LEGGI TUTTO</Link>
                                        </div>
                                    </div>
                                ))
                            )}
                        </div>
                    </div>
                    <BlogSidebar blLeft={props.blLeft} />
                </div>
            </div>
        </section>
    )
}

export default BlogList;
